module.exports = __webpack_public_path__ + "img/tmpType-nothing.233c1ca3.png";